import request from '@/utils/request'

export function getOrderPrice(data) {
	return request({
		url: '/open/order/price',
		method: 'post',
		data
	})
}
